import React from 'react';
import { cx } from './clases';

interface Props {
  /** Texto de la etiqueta (13/600). Siempre hay etiqueta: si no se ve, `etiquetaOculta`. */
  etiqueta: React.ReactNode;
  /** `id` del control. Con él, la etiqueta es un `<label htmlFor>` real. */
  htmlFor?: string;
  children: React.ReactNode;
  /** Ayuda bajo el control, en gris. */
  ayuda?: React.ReactNode;
  /** Error de campo, en rojo, con `role="alert"`. Si hay error, la ayuda no se muestra. */
  error?: React.ReactNode;
  /** La etiqueta existe para el lector de pantalla pero no se ve (p. ej. en una celda). */
  etiquetaOculta?: boolean;
  className?: string;
}

/**
 * Etiqueta + control + ayuda o error, con la separación del diseño (6 px).
 * El control lo pone quien lo usa (Dropdown, InputText, un `select` propio con
 * `CLASES_CAMPO`…); `Field` sólo lo nombra y lo acompaña.
 */
export const Field: React.FC<Props> = ({ etiqueta, htmlFor, children, ayuda, error, etiquetaOculta, className }) => {
  const claseEtiqueta = cx('text-metas-label text-metas-texto-3', etiquetaOculta && 'sr-only');
  return (
    <div className={cx('flex min-w-0 flex-col gap-1.5', className)}>
      {htmlFor ? (
        <label htmlFor={htmlFor} className={claseEtiqueta}>
          {etiqueta}
        </label>
      ) : (
        <span className={claseEtiqueta}>{etiqueta}</span>
      )}
      {children}
      {error ? (
        <span role="alert" className="text-xs font-semibold text-metas-error">
          {error}
        </span>
      ) : (
        ayuda && <span className="text-xs text-metas-texto-2">{ayuda}</span>
      )}
    </div>
  );
};

export default Field;
